// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__Mqq8x","project_intro":"Projects_project_intro__pfFMA"};